/* ==========================================================================
   Lovedrunk — Theme JS (Vanilla, kein Framework)
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ helpers */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function lockScroll() { document.body.classList.add('ld-no-scroll'); }
  function unlockScroll() {
    if (!document.querySelector('.ld-menu.is-open, .ld-drawer.is-open, .ld-qa.is-open')) {
      document.body.classList.remove('ld-no-scroll');
    }
  }

  var moneyFormat = (window.LD_SETTINGS && window.LD_SETTINGS.moneyFormat) || '€ {{amount_with_comma_separator}}';

  function formatMoney(cents) {
    var amount = (cents / 100);
    var str = amount.toFixed(2).replace('.', ',');
    var parts = str.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€ ' + parts.join(',');
  }

  function toast(msg) {
    var el = $('#ld-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-open');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-open'); }, 2600);
  }

  /* ------------------------------------------------------ sticky header */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------------------------------------------------------ menu overlay */
  function initMenu() {
    var menu = $('[data-menu]');
    if (!menu) return;
    var openers = $$('[data-menu-open]');
    var closers = $$('[data-menu-close]');

    function setStagger() {
      $$('.ld-menu__item', menu).forEach(function (item, i) {
        item.style.transitionDelay = (200 + i * 60) + 'ms';
      });
    }
    function clearStagger() {
      $$('.ld-menu__item', menu).forEach(function (item) { item.style.transitionDelay = '0ms'; });
    }

    function open() {
      setStagger();
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      lockScroll();
      var first = $('.ld-menu__link, .ld-menu__toggle', menu);
      if (first) setTimeout(function () { first.focus(); }, 620);
    }
    function close() {
      clearStagger();
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      $$('[data-menu-toggle]', menu).forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.remove('is-open');
      });
      unlockScroll();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });

    $$('[data-menu-toggle]', menu).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        $$('[data-menu-toggle]', menu).forEach(function (other) {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          var p = document.getElementById(other.getAttribute('aria-controls'));
          if (p) p.classList.remove('is-open');
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });

    $$('a', menu).forEach(function (a) {
      a.addEventListener('click', function () { close(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });
  }

  /* ------------------------------------------------------- hero slider */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      if (hero._ldHeroInit) return;
      var slides = $$('[data-hero-slide]', hero);
      var dots = $$('[data-hero-dot]', hero);
      if (slides.length < 2) return;
      hero._ldHeroInit = true;
      var idx = 0;
      var interval = parseInt(hero.getAttribute('data-hero-interval'), 10) || 6000;
      var timer = null;

      function go(i) {
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === idx);
          s.setAttribute('aria-hidden', n === idx ? 'false' : 'true');
        });
        /* Ring-Animation neu starten: erst alle Dots inaktiv, Reflow, dann aktiven setzen */
        dots.forEach(function (d) { d.classList.remove('is-active'); });
        void hero.offsetWidth;
        dots.forEach(function (d, n) {
          if (n === idx) d.classList.add('is-active');
          d.setAttribute('aria-current', n === idx ? 'true' : 'false');
        });
        hero.classList.toggle('ld-hero--dark', slides[idx].getAttribute('data-theme') === 'dark');
      }
      function start() {
        if (reduceMotion) return;
        stop();
        timer = setInterval(function () { go(idx + 1); }, interval);
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { go(n); start(); });
      });

      /* Pause nur bei echter Maus (auf dem Handy wuerde Tippen sonst den Slider stoppen) */
      hero.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        stop();
        hero.classList.add('is-paused');
      });
      hero.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        hero.classList.remove('is-paused');
        go(idx);
        start();
      });

      /* Wischen auf dem Handy */
      var sx = 0, sy = 0, tracking = false;
      hero.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        tracking = true;
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx;
        var dy = t.clientY - sy;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          go(dx < 0 ? idx + 1 : idx - 1);
          start();
        }
      }, { passive: true });

      go(0);
      start();
    });
  }

  /* ---------------------------------------------------- scroll reveals */
  function initReveal() {
    var els = $$('.ld-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------ community scroller */
  function initScrollers() {
    $$('[data-scroller-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-target'));
        if (target) target.scrollBy({ left: -target.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
    $$('[data-scroller-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.getAttribute('data-target'));
        if (target) target.scrollBy({ left: target.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  }

  /* ---------------------------------------------------------- cart API */
  var CartAPI = {
    get: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); });
    },
    add: function (id, qty) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      });
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ------------------------------------------------------- cart drawer */
  var Drawer = {
    el: null, backdrop: null, body: null, foot: null, ship: null, count: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      this.backdrop = $('[data-cart-backdrop]');
      if (!this.el) return;
      this.body = $('[data-cart-body]', this.el);
      this.foot = $('[data-cart-foot]', this.el);
      this.ship = $('[data-cart-ship]', this.el);

      var self = this;
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          self.open();
        });
      });
      $$('[data-cart-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      if (this.backdrop) this.backdrop.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });

      this.body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        var key = btn.getAttribute('data-key');
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        self.setLoading(true);
        CartAPI.change(key, qty).then(function (cart) {
          self.render(cart);
          self.updateCount(cart.item_count);
          self.setLoading(false);
        });
      });
    },

    setLoading: function (on) { if (this.el) this.el.classList.toggle('is-loading', !!on); },

    open: function () {
      var self = this;
      CartAPI.get().then(function (cart) {
        self.render(cart);
        self.updateCount(cart.item_count);
        self.el.classList.add('is-open');
        self.el.setAttribute('aria-hidden', 'false');
        if (self.backdrop) self.backdrop.classList.add('is-open');
        lockScroll();
        var closeBtn = $('[data-cart-close]', self.el);
        if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 300);
      });
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (this.backdrop) this.backdrop.classList.remove('is-open');
      unlockScroll();
    },

    updateCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    },

    render: function (cart) {
      if (!this.body) return;
      var t = (window.LD_STRINGS || {});
      if (!cart.items || !cart.items.length) {
        this.body.innerHTML = '<p class="ld-drawer__empty">' + (t.cartEmpty || 'Dein Warenkorb ist leer.') + '</p>';
        if (this.foot) this.foot.hidden = true;
        if (this.ship) this.ship.hidden = true;
        return;
      }
      if (this.foot) this.foot.hidden = false;
      if (this.ship) this.ship.hidden = false;

      var html = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">'
          : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<p class="ld-lineitem__variant">' + item.variant_title + '</p>' : '';
        return '' +
          '<div class="ld-lineitem">' +
            '<div class="ld-lineitem__img">' + img + '</div>' +
            '<div class="ld-lineitem__info">' +
              '<p class="ld-lineitem__title">' + item.product_title + '</p>' +
              variant +
              '<p class="ld-lineitem__price">' + formatMoney(item.final_line_price) + '</p>' +
              '<div class="ld-lineitem__row">' +
                '<div class="ld-qty">' +
                  '<button type="button" data-line-change data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Menge verringern">&minus;</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-line-change data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
                '</div>' +
                '<button type="button" class="ld-lineitem__remove" data-line-change data-key="' + item.key + '" data-qty="0">' + (t.remove || 'Entfernen') + '</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');
      this.body.innerHTML = html;

      var totalEl = $('[data-cart-total]', this.el);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      var threshold = (window.LD_SETTINGS && window.LD_SETTINGS.freeShippingCents) || 0;
      if (this.ship && threshold > 0) {
        var remaining = threshold - cart.total_price;
        var txt = $('[data-ship-text]', this.ship);
        var fill = $('[data-ship-fill]', this.ship);
        if (remaining > 0) {
          if (txt) txt.textContent = (t.shipRemaining || 'Noch {amount} bis Gratisversand').replace('{amount}', formatMoney(remaining));
          if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
        } else {
          if (txt) txt.textContent = t.shipReached || 'Gratisversand freigeschaltet.';
          if (fill) fill.style.width = '100%';
        }
      }
    }
  };

  /* ------------------------------------------------ product form (PDP) */
  function initProductForm() {
    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idInput = $('[name="id"]', form);
        var qtyInput = $('[name="quantity"]', form);
        if (!idInput || !idInput.value) return;
        var btn = $('[type="submit"]', form);
        if (btn) btn.disabled = true;
        CartAPI.add(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1)
          .then(function () {
            if (btn) btn.disabled = false;
            Drawer.open();
          })
          .catch(function (err) {
            if (btn) btn.disabled = false;
            toast((err && err.description) || 'Nicht verfügbar.');
          });
      });
    });
  }

  /* ---------------------------------------------- variant picker (PDP) */
  function initVariantPicker() {
    $$('[data-variant-picker]').forEach(function (root) {
      var raw = root.getAttribute('data-variants');
      var variants;
      try { variants = JSON.parse(raw); } catch (e) { return; }
      var optionCount = parseInt(root.getAttribute('data-option-count'), 10) || 1;
      var idInput = $('[data-variant-id]');
      var priceEl = $('[data-variant-price]');
      var addBtn = $('[data-add-btn]');
      var selected = [];

      var initial = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (initial) selected = initial.options.slice(0, optionCount);

      function paint() {
        $$('[data-option-value]', root).forEach(function (btn) {
          var pos = parseInt(btn.getAttribute('data-option-index'), 10);
          var val = btn.getAttribute('data-option-value');
          btn.classList.toggle('is-active', selected[pos] === val);
          var probe = selected.slice();
          probe[pos] = val;
          var match = variants.filter(function (v) {
            for (var i = 0; i < optionCount; i++) {
              if (i === pos) { if (v.options[i] !== val) return false; }
              else if (probe[i] && v.options[i] !== probe[i]) return false;
            }
            return true;
          });
          var anyAvailable = match.some(function (v) { return v.available; });
          btn.classList.toggle('is-unavailable', !anyAvailable);
        });

        var current = variants.filter(function (v) {
          for (var i = 0; i < optionCount; i++) { if (v.options[i] !== selected[i]) return false; }
          return true;
        })[0];

        if (current) {
          if (idInput) idInput.value = current.id;
          if (priceEl) {
            var html = formatMoney(current.price);
            if (current.compare_at_price && current.compare_at_price > current.price) {
              html = '<s>' + formatMoney(current.compare_at_price) + '</s>' + html;
            }
            priceEl.innerHTML = html;
          }
          if (addBtn) {
            addBtn.disabled = !current.available;
            addBtn.textContent = current.available
              ? ((window.LD_STRINGS || {}).addToCart || 'In den Warenkorb')
              : ((window.LD_STRINGS || {}).soldOut || 'Ausverkauft');
          }
          if (current.featured_image_index != null) {
            var thumb = $('[data-pdp-thumb][data-index="' + current.featured_image_index + '"]');
            if (thumb) thumb.click();
          }
        } else if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = (window.LD_STRINGS || {}).unavailable || 'Nicht verfügbar';
        }
      }

      $$('[data-option-value]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.getAttribute('data-option-index'), 10);
          selected[pos] = btn.getAttribute('data-option-value');
          paint();
        });
      });

      paint();
    });
  }

  /* -------------------------------------------------------- pdp gallery */
  function initGallery() {
    var main = $('[data-pdp-main]');
    if (!main) return;
    $$('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var img = $('img', main);
        if (img && src) {
          img.src = src;
          if (srcset) img.srcset = srcset;
        }
      });
    });
  }

  /* ------------------------------------------------------------ accordion */
  function initAccordions() {
    $$('[data-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !expanded);
      });
    });
  }

  /* -------------------------------------------------------------- init */
  function init() {
    initHeader();
    initMenu();
    initHero();
    initReveal();
    initScrollers();
    Drawer.init();
    initProductForm();
    initVariantPicker();
    initGallery();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { init(); });
})();
